export default class SegmentEventType {
  /**
   * This is a static method that returns an instance of the "Track" class.
   * @returns The `Track` instance is being returned. It is obtained by calling the `getInstance`
   * method of the current class (`this`) and passing in the string `'Track'` as an argument.
   */
  static get Track() {
    return this.getInstance('Track');
  }

  /**
   * This is a static method that returns an instance of the "Impression" class.
   * @returns The `Impression` instance is being returned. It is obtained by calling the `getInstance`
   * method of the current class (`this`) and passing in the string `'Impression'` as an argument.
   */
  static get Impression() {
    return this.getInstance('Impression');
  }

  /**
   * This is a static method that returns an instance of the "Identify" class.
   * @returns The `Identify` instance is being returned. It is obtained by calling the `getInstance`
   * method of the current class (`this`) and passing in the string `'Identify'` as an argument.
   */
  static get Identify() {
    return this.getInstance('Identify');
  }

  /**
   * This is a static method that returns an instance of the "PageView" class.
   * @returns The `PageView` instance is being returned. It is obtained by calling the `getInstance`
   * method of the current class (`this`) and passing in the string `'PageView'` as an argument.
   */
  static get PageView() {
    return this.getInstance('PageView');
  }

  /**
   * The function returns a value from a map based on the input name.
   *
   * @param name - The name of the key in the `statusMap` object that we want to retrieve the value for.
   *
   * @returns the value of the `statusMap` object that corresponds to the `name` parameter passed to the function.
   * If `name` matches one of the keys in `statusMap`, the corresponding value is returned.
   */
  static fromKey(key) {
    const statusMap = {
      Track: SegmentEventType.Track,
      Impression: SegmentEventType.Impression,
      Identify: SegmentEventType.Identify,
      PageView: SegmentEventType.PageView,
    };
    return statusMap[key];
  }

  /**
   * Gets an instance of a SegmentEventType object based on a given name.
   * If the instance does not already exist, it creates a new instance using the configuration provided.
   *
   * @param name a unique identifier used to retrieve or create an instance of the SegmentEventType class.
   * @param configuration an object that contains various properties and values that are used to configure
   * the instance of the SegmentEventType class that is being created.
   *
   * @returns an instance of `SegmentEventType` that corresponds to the given `name`.
   */
  static getInstance(key) {
    if (!this.instances[key]) {
      this.instances[key] = new SegmentEventType(key);
    }
    return this.instances[key];
  }

  /**
   * This is a constructor function that takes a name as a parameter and sets the name
   * @param name -The `name` property is a string that represents the name of the
   * configuration
   */
  constructor(name) {
    this.name = name;
  }

  /**
   * Method that returns the name property of an object as a string.
   * @returns returns the `name` property of that object as a string.
   */
  toString() {
    return `${this.name}`;
  }
}

Object.defineProperty(SegmentEventType, 'instances', { value: {} });
